<template>
  <div>
    <div class="d-flex justify-content-center mb-3 spinner">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    
  </div>




</template>

<script>
  //import { mapGetters } from 'vuex'
  export default {
    name: "ExternalResponse",
    data() {
      return {
         
      }
    },
    props:{
     lang: Object
    },
    computed:{
      
    },
    methods: {
      
    },
    created: function () {

    

      let vue = this;

      const obj = {
        code: this.$route.query.code
      }

      this.$store.dispatch("approveToken", obj)
      .then( result => {

        if (result.status == "OK"){

          const obj = {
            text: vue.lang.ExternalResponse.alert_success_approveToken,
            time: 5,
            type: "success"
          }

          
          vue.$store.dispatch("displayFooterAlert", obj);

          vue.$router.push({path: '/Settings/Main?active=searchEngines'});
        }else{
          const obj = {
            text: vue.lang.ExternalResponse.alert_error_approveToken,
            time: 15,
            type: "danger"
          }

          
          vue.$store.dispatch("displayFooterAlert", obj);

          vue.$router.push({path: '/Settings/Main?active=searchEngines'});
        }

      })


    }
  }
</script>
<style scope>
  .spinner{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ExternalResponse.vue